/// <amd-module name="Artifacts/Root/helpers/LocStringHelpers" />

import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import * as StringUtils from "VSS/Core/Util/String";

/**
 * Returns a localized string to refer to package versions.
 * If more than 1 version, just refer to the versions by quantity
 * @param versions package versions to represent as a string for user-facing messages
 */
export function getPackageVersionsAlias(versions: IPackageVersionIdentity[]): string {
  return versions.length > 1
    ? StringUtils.format(Res.MultipleSelectedPackages, versions.length)
    : `${versions[0].name} ${versions[0].version}`;
}
